import React, { useEffect, useRef } from "react";
import "./Education.scss";

import { motion } from "framer-motion";
import ReactTooltip from "react-tooltip";

import { AppWrap, MotionWrap } from "../../wrapper";
// import { images } from "../../constants";
import Lottie from "lottie-web";

const Education = () => {
  const container = useRef(null);

  useEffect(() => {
    Lottie.loadAnimation({
      container: container.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: require("../../assets/dot.json"),
    });
  }, []);

  const experiences = [
    {
      year: "2022",
      works: [
        {
          name: "Full Stack Web Development ",
          school: "Masai School",
          desc: "Masai School offers 30 weeks course for full stack web development. At Masai, we are learning by doing, we get hands on experience to learn front end and back end technology",
        },
      ],
    },
    {
      year: "2022",
      works: [
        {
          name: "Bachelor of Education",
          school: "Chhatrapati Shahu Ji Maharaj University, Kanpur",
          desc: "A Bachelor of Education is an undergraduate professional degree which prepares students for work as a teacher in schools.",
        },
      ],
    },
    {
      year: "2018",
      works: [
        {
          name: "Bachelor of Science (Coumputer Application) ",
          school: "Chhatrapati Shahu Ji Maharaj University, Kanpur",
          desc: "A Bachelor of Science is a bachelor s degree awarded for programs. I did 3 years degree course",
        },
      ],
    },
    {
      year: "2015",
      works: [
        {
          name: "Intermediate 12th (Science)",
          school:
            "Board of High School and Intermediate Education Uttar Pradesh",
          desc: "The Board of High School and Intermediate Education Uttar Pradesh is the Uttar Pradesh state government",
        },
      ],
    },
  ];

  return (
    <>
      <div
        className="container"
        ref={container}
        style={{
          // width: "200%",
          // height: "100%",
          position: "absolute",
          zIndex: 1,
          overflow: "hidden",
          animation: "infinite",
          // borderRadius: "50%",
        }}
      ></div>
      <h2 className="head-text">Education</h2>

      <div className="app__skills-container" style={{ zIndex: 2 }}>
        <div className="app__skills-exp">
          {experiences.map((experience) => (
            <motion.div className="app__skills-exp-item" key={experience.year}>
              <img
                src={require("../../assets/document.gif")}
                alt="loading..."
                className="app__document-img"
                style={{ width: "40px", marginRight: "20px" }}
              />
              <div className="app__skills-exp-year">
                <p className="bold-text">{experience.year}</p>
              </div>
              <motion.div className="app__skills-exp-works">
                {/* {console.log(experience.works.name)}
                {experience.works.map((e) => console.log(e))} */}
                {experience.works.map((work) => (
                  <>
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className="app__skills-exp-work"
                      data-tip
                      data-for={work.name}
                      key={work.name}
                    >
                      <h4 className="bold-text">{work.name}</h4>
                      <p className="p-text">{work.school}</p>
                    </motion.div>
                    <ReactTooltip
                      id={work.name}
                      effect="solid"
                      arrowColor="#fff"
                      className="skills-tooltip"
                    >
                      {work.desc}
                    </ReactTooltip>
                  </>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Education, "app__skills"),
  "education",
  "app__whitebg"
);
